import React from "react";

import { Row, Col, Card, CardBody, Container, CardHeader } from "reactstrap";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const IconDripicons = () => {
  document.title = "Boxicons | Khozi";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Icons" breadcrumbItem="Boxicons" />

          <Row>
            <Col xs="12">
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <h4 className="card-title">Examples</h4>
                  
                  <Link to="//boxicons.com/" target="_blank" rel="noreferrer" className="btn btn-sm btn-secondary-subtle">Docs <i className="mdi mdi-arrow-right align-middle"></i></Link>
                </CardHeader>
                <CardBody>
                  <h5>Regular</h5>
                  <Row className="icon-demo-content">
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sticker"></i> bx bx-sticker
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shield-quarter"></i> bx
                      bx-shield-quarter
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-upside-down"></i> bx bx-upside-down
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-laugh"></i> bx bx-laugh
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-meh-blank"></i> bx bx-meh-blank
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-happy-beaming"></i> bx
                      bx-happy-beaming
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shocked"></i> bx bx-shocked
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sleepy"></i> bx bx-sleepy
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-confused"></i> bx bx-confused
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wink-smile"></i> bx bx-wink-smile
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dizzy"></i> bx bx-dizzy
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-happy-heart-eyes"></i> bx
                      bx-happy-heart-eyes
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-angry"></i> bx bx-angry
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-smile"></i> bx bx-smile
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-tired"></i> bx bx-tired
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cool"></i> bx bx-cool
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-happy-alt"></i> bx bx-happy-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wink-tongue"></i> bx bx-wink-tongue
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-meh-alt"></i> bx bx-meh-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-food-menu"></i> bx bx-food-menu
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-food-tag"></i> bx bx-food-tag
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-female-sign"></i> bx bx-female-sign
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-male-sign"></i> bx bx-male-sign
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-female"></i> bx bx-female
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-male"></i> bx bx-male
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-clinic"></i> bx bx-clinic
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-health"></i> bx bx-health
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shekel"></i> bx bx-shekel
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-yen"></i> bx bx-yen
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-won"></i> bx bx-won
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pound"></i> bx bx-pound
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-euro"></i> bx bx-euro
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rupee"></i> bx bx-rupee
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-ruble"></i> bx bx-ruble
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-lira"></i> bx bx-lira
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bitcoin"></i> bx bx-bitcoin
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-tone"></i> bx bx-tone
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bolt-circle"></i> bx bx-bolt-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cake"></i> bx bx-cake
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-spa"></i> bx bx-spa
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dish"></i> bx bx-dish
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-fridge"></i> bx bx-fridge
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-image-add"></i> bx bx-image-add
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-image-alt"></i> bx bx-image-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-space-bar"></i> bx bx-space-bar
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-alarm-add"></i> bx bx-alarm-add
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-archive-out"></i> bx bx-archive-out
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-archive-in"></i> bx bx-archive-in
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-add-to-queue"></i> bx bx-add-to-queue
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-border-radius"></i> bx
                      bx-border-radius
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-check-shield"></i> bx bx-check-shield
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-label"></i> bx bx-label
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-file-find"></i> bx bx-file-find
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-face"></i> bx bx-face
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-extension"></i> bx bx-extension
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-exit"></i> bx bx-exit
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-conversation"></i> bx bx-conversation
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sort-z-a"></i> bx bx-sort-z-a
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sort-a-z"></i> bx bx-sort-a-z
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-printer"></i> bx bx-printer
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-radio"></i> bx bx-radio
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-customize"></i> bx bx-customize
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-brush-alt"></i> bx bx-brush-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-briefcase-alt-2"></i> bx
                      bx-briefcase-alt-2
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-time-five"></i> bx bx-time-five
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pie-chart-alt-2"></i> bx
                      bx-pie-chart-alt-2
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-gas-pump"></i> bx bx-gas-pump
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mobile-vibration"></i> bx
                      bx-mobile-vibration
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mobile-landscape"></i> bx
                      bx-mobile-landscape
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-border-all"></i> bx bx-border-all
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-border-bottom"></i> bx
                      bx-border-bottom
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-border-top"></i> bx bx-border-top
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-border-left"></i> bx bx-border-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-border-right"></i> bx bx-border-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dialpad-alt"></i> bx bx-dialpad-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-filter-alt"></i> bx bx-filter-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-brightness"></i> bx bx-brightness
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-brightness-half"></i> bx
                      bx-brightness-half
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wifi-off"></i> bx bx-wifi-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-credit-card-alt"></i> bx
                      bx-credit-card-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-band-aid"></i> bx bx-band-aid
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-hive"></i> bx bx-hive
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-map-pin"></i> bx bx-map-pin
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-line-chart"></i> bx bx-line-chart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-receipt"></i> bx bx-receipt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-purchase-tag-alt"></i> bx
                      bx-purchase-tag-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-basket"></i> bx bx-basket
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-palette"></i> bx bx-palette
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-no-entry"></i> bx bx-no-entry
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-alt-dots"></i> bx
                      bx-message-alt-dots
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-alt"></i> bx bx-message-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-check-square"></i> bx bx-check-square
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-log-out-circle"></i> bx
                      bx-log-out-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-log-in-circle"></i> bx
                      bx-log-in-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-doughnut-chart"></i> bx
                      bx-doughnut-chart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-building-house"></i> bx
                      bx-building-house
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-accessibility"></i> bx
                      bx-accessibility
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-voice"></i> bx bx-user-voice
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cuboid"></i> bx bx-cuboid
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cube-alt"></i> bx bx-cube-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-polygon"></i> bx bx-polygon
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-square-rounded"></i> bx
                      bx-square-rounded
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-square"></i> bx bx-square
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-error-alt"></i> bx bx-error-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shield-alt-2"></i> bx bx-shield-alt-2
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-paint-roll"></i> bx bx-paint-roll
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-droplet"></i> bx bx-droplet
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-street-view"></i> bx bx-street-view
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-plus-medical"></i> bx bx-plus-medical
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-search-alt-2"></i> bx bx-search-alt-2
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bowling-ball"></i> bx bx-bowling-ball
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dna"></i> bx bx-dna
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cycling"></i> bx bx-cycling
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shape-circle"></i> bx bx-shape-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-down-arrow-alt"></i> bx
                      bx-down-arrow-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-up-arrow-alt"></i> bx bx-up-arrow-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-right-arrow-alt"></i> bx
                      bx-right-arrow-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-left-arrow-alt"></i> bx
                      bx-left-arrow-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-lock-open-alt"></i> bx
                      bx-lock-open-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-lock-alt"></i> bx bx-lock-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cylinder"></i> bx bx-cylinder
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pyramid"></i> bx bx-pyramid
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-comment-dots"></i> bx bx-comment-dots
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-comment"></i> bx bx-comment
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-landscape"></i> bx bx-landscape
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-book-open"></i> bx bx-book-open
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-transfer-alt"></i> bx bx-transfer-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-copy-alt"></i> bx bx-copy-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-run"></i> bx bx-run
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-pin"></i> bx bx-user-pin
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-grid"></i> bx bx-grid
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-code-alt"></i> bx bx-code-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mail-send"></i> bx bx-mail-send
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-ghost"></i> bx bx-ghost
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shape-triangle"></i> bx
                      bx-shape-triangle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shape-square"></i> bx bx-shape-square
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-video-recording"></i> bx
                      bx-video-recording
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-notepad"></i> bx bx-notepad
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bug-alt"></i> bx bx-bug-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mouse-alt"></i> bx bx-mouse-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-edit-alt"></i> bx bx-edit-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chat"></i> bx bx-chat
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-book-content"></i> bx bx-book-content
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-square-dots"></i> bx
                      bx-message-square-dots
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-square"></i> bx
                      bx-message-square
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-slideshow"></i> bx bx-slideshow
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wallet-alt"></i> bx bx-wallet-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-memory-card"></i> bx bx-memory-card
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-rounded-dots"></i> bx
                      bx-message-rounded-dots
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-dots"></i> bx bx-message-dots
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bar-chart-alt-2"></i> bx
                      bx-bar-chart-alt-2
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-store-alt"></i> bx bx-store-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-buildings"></i> bx bx-buildings
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-home-circle"></i> bx bx-home-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-money"></i> bx bx-money
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-walk"></i> bx bx-walk
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-repeat"></i> bx bx-repeat
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-font-family"></i> bx bx-font-family
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-joystick-button"></i> bx
                      bx-joystick-button
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-paint"></i> bx bx-paint
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-unlink"></i> bx bx-unlink
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-brush"></i> bx bx-brush
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rotate-left"></i> bx bx-rotate-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-badge-check"></i> bx bx-badge-check
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-show-alt"></i> bx bx-show-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-caret-down"></i> bx bx-caret-down
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-caret-right"></i> bx bx-caret-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-caret-up"></i> bx bx-caret-up
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-caret-left"></i> bx bx-caret-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar-event"></i> bx
                      bx-calendar-event
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-magnet"></i> bx bx-magnet
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rewind-circle"></i> bx
                      bx-rewind-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-card"></i> bx bx-card
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-help-circle"></i> bx bx-help-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-test-tube"></i> bx bx-test-tube
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-note"></i> bx bx-note
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sort-down"></i> bx bx-sort-down
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sort-up"></i> bx bx-sort-up
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-id-card"></i> bx bx-id-card
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-badge"></i> bx bx-badge
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-grid-small"></i> bx bx-grid-small
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-grid-vertical"></i> bx
                      bx-grid-vertical
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-grid-horizontal"></i> bx
                      bx-grid-horizontal
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-move-vertical"></i> bx
                      bx-move-vertical
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-move-horizontal"></i> bx
                      bx-move-horizontal
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-stats"></i> bx bx-stats
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-equalizer"></i> bx bx-equalizer
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-disc"></i> bx bx-disc
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-analyse"></i> bx bx-analyse
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-search-alt"></i> bx bx-search-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dollar-circle"></i> bx
                      bx-dollar-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-football"></i> bx bx-football
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-ball"></i> bx bx-ball
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-circle"></i> bx bx-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-transfer"></i> bx bx-transfer
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-fingerprint"></i> bx bx-fingerprint
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-font-color"></i> bx bx-font-color
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-highlight"></i> bx bx-highlight
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-file-blank"></i> bx bx-file-blank
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-strikethrough"></i> bx
                      bx-strikethrough
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-photo-album"></i> bx bx-photo-album
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-code-block"></i> bx bx-code-block
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-font-size"></i> bx bx-font-size
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-handicap"></i> bx bx-handicap
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dialpad"></i> bx bx-dialpad
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wind"></i> bx bx-wind
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-water"></i> bx bx-water
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-swim"></i> bx bx-swim
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-restaurant"></i> bx bx-restaurant
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-box"></i> bx bx-box
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-menu-alt-right"></i> bx
                      bx-menu-alt-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-menu-alt-left"></i> bx
                      bx-menu-alt-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-video-plus"></i> bx bx-video-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-list-ol"></i> bx bx-list-ol
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-planet"></i> bx bx-planet
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-hotel"></i> bx bx-hotel
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-movie"></i> bx bx-movie
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-taxi"></i> bx bx-taxi
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-train"></i> bx bx-train
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bath"></i> bx bx-bath
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bed"></i> bx bx-bed
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-area"></i> bx bx-area
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bot"></i> bx bx-bot
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dumbbell"></i> bx bx-dumbbell
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-check-double"></i> bx bx-check-double
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bus"></i> bx bx-bus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-check-circle"></i> bx bx-check-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rocket"></i> bx bx-rocket
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-certification"></i> bx
                      bx-certification
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-slider-alt"></i> bx bx-slider-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sad"></i> bx bx-sad
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-meh"></i> bx bx-meh
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-happy"></i> bx bx-happy
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cart-alt"></i> bx bx-cart-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-car"></i> bx bx-car
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-loader-alt"></i> bx bx-loader-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-loader-circle"></i> bx
                      bx-loader-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wrench"></i> bx bx-wrench
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-alarm-off"></i> bx bx-alarm-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-layout"></i> bx bx-layout
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dock-left"></i> bx bx-dock-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dock-top"></i> bx bx-dock-top
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dock-right"></i> bx bx-dock-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dock-bottom"></i> bx bx-dock-bottom
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dock-bottom"></i> bx bx-dock-bottom
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-world"></i> bx bx-world
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-selection"></i> bx bx-selection
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-paper-plane"></i> bx bx-paper-plane
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-slider"></i> bx bx-slider
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-loader"></i> bx bx-loader
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chalkboard"></i> bx bx-chalkboard
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-trash-alt"></i> bx bx-trash-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-grid-alt"></i> bx bx-grid-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-command"></i> bx bx-command
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-window-close"></i> bx bx-window-close
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-notification-off"></i> bx
                      bx-notification-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-plug"></i> bx bx-plug
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-infinite"></i> bx bx-infinite
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-carousel"></i> bx bx-carousel
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-hourglass"></i> bx bx-hourglass
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-briefcase-alt"></i> bx
                      bx-briefcase-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wallet"></i> bx bx-wallet
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-station"></i> bx bx-station
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-collection"></i> bx bx-collection
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-tv"></i> bx bx-tv
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-closet"></i> bx bx-closet
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-paperclip"></i> bx bx-paperclip
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-expand"></i> bx bx-expand
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pen"></i> bx bx-pen
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-purchase-tag"></i> bx bx-purchase-tag
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-images"></i> bx bx-images
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pie-chart-alt"></i> bx
                      bx-pie-chart-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-news"></i> bx bx-news
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-downvote"></i> bx bx-downvote
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-upvote"></i> bx bx-upvote
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-globe-alt"></i> bx bx-globe-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-store"></i> bx bx-store
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-hdd"></i> bx bx-hdd
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-skip-previous-circle"></i> bx
                      bx-skip-previous-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-skip-next-circle"></i> bx
                      bx-skip-next-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chip"></i> bx bx-chip
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cast"></i> bx bx-cast
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-body"></i> bx bx-body
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-phone-outgoing"></i> bx
                      bx-phone-outgoing
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-phone-incoming"></i> bx
                      bx-phone-incoming
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-collapse"></i> bx bx-collapse
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rename"></i> bx bx-rename
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rotate-right"></i> bx bx-rotate-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-horizontal-center"></i> bx
                      bx-horizontal-center
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-ruler"></i> bx bx-ruler
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-import"></i> bx bx-import
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar-alt"></i> bx bx-calendar-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-battery"></i> bx bx-battery
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-server"></i> bx bx-server
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-task"></i> bx bx-task
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-folder-open"></i> bx bx-folder-open
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-film"></i> bx bx-film
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-aperture"></i> bx bx-aperture
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-phone-call"></i> bx bx-phone-call
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-up-arrow"></i> bx bx-up-arrow
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-undo"></i> bx bx-undo
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-timer"></i> bx bx-timer
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-support"></i> bx bx-support
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-subdirectory-right"></i> bx
                      bx-subdirectory-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-right-arrow"></i> bx bx-right-arrow
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-revision"></i> bx bx-revision
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-repost"></i> bx bx-repost
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-reply"></i> bx bx-reply
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-reply-all"></i> bx bx-reply-all
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-redo"></i> bx bx-redo
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-radar"></i> bx bx-radar
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-poll"></i> bx bx-poll
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-list-check"></i> bx bx-list-check
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-like"></i> bx bx-like
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-left-arrow"></i> bx bx-left-arrow
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-joystick-alt"></i> bx bx-joystick-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-history"></i> bx bx-history
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-flag"></i> bx bx-flag
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-first-aid"></i> bx bx-first-aid
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-export"></i> bx bx-export
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-down-arrow"></i> bx bx-down-arrow
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dislike"></i> bx bx-dislike
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-crown"></i> bx bx-crown
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-barcode"></i> bx bx-barcode
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user"></i> bx bx-user
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-x"></i> bx bx-user-x
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-plus"></i> bx bx-user-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-minus"></i> bx bx-user-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-circle"></i> bx bx-user-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-user-check"></i> bx bx-user-check
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-underline"></i> bx bx-underline
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-trophy"></i> bx bx-trophy
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-trash"></i> bx bx-trash
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-text"></i> bx bx-text
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sun"></i> bx bx-sun
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-star"></i> bx bx-star
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sort"></i> bx bx-sort
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shuffle"></i> bx bx-shuffle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shopping-bag"></i> bx bx-shopping-bag
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shield"></i> bx bx-shield
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-shield-alt"></i> bx bx-shield-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-share"></i> bx bx-share
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-share-alt"></i> bx bx-share-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-select-multiple"></i> bx
                      bx-select-multiple
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-screenshot"></i> bx bx-screenshot
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-save"></i> bx bx-save
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pulse"></i> bx bx-pulse
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-power-off"></i> bx bx-power-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-plus"></i> bx bx-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pin"></i> bx bx-pin
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pencil"></i> bx bx-pencil
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pin"></i> bx bx-pin
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pencil"></i> bx bx-pencil
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-paste"></i> bx bx-paste
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-paragraph"></i> bx bx-paragraph
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-package"></i> bx bx-package
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-notification"></i> bx bx-notification
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-music"></i> bx bx-music
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-move"></i> bx bx-move
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mouse"></i> bx bx-mouse
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-minus"></i> bx bx-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-microphone-off"></i> bx
                      bx-microphone-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-log-out"></i> bx bx-log-out
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-log-in"></i> bx bx-log-in
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-link-external"></i> bx
                      bx-link-external
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-joystick"></i> bx bx-joystick
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-italic"></i> bx bx-italic
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-home-alt"></i> bx bx-home-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-heading"></i> bx bx-heading
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-hash"></i> bx bx-hash
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-group"></i> bx bx-group
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-git-repo-forked"></i> bx
                      bx-git-repo-forked
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-git-pull-request"></i> bx
                      bx-git-pull-request
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-git-merge"></i> bx bx-git-merge
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-git-compare"></i> bx bx-git-compare
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-git-commit"></i> bx bx-git-commit
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-git-branch"></i> bx bx-git-branch
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-font"></i> bx bx-font
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-filter"></i> bx bx-filter
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-file"></i> bx bx-file
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-edit"></i> bx bx-edit
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-diamond"></i> bx bx-diamond
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-detail"></i> bx bx-detail
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cut"></i> bx bx-cut
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cube"></i> bx bx-cube
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-crop"></i> bx bx-crop
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-credit-card"></i> bx bx-credit-card
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-columns"></i> bx bx-columns
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cog"></i> bx bx-cog
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-snow"></i> bx bx-cloud-snow
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-rain"></i> bx bx-cloud-rain
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-lightning"></i> bx
                      bx-cloud-lightning
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-light-rain"></i> bx
                      bx-cloud-light-rain
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-drizzle"></i> bx
                      bx-cloud-drizzle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-check"></i> bx bx-check
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cart"></i> bx bx-cart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calculator"></i> bx bx-calculator
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bold"></i> bx bx-bold
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-award"></i> bx bx-award
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-anchor"></i> bx bx-anchor
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-album"></i> bx bx-album
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-adjust"></i> bx bx-adjust
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-x"></i> bx bx-x
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-table"></i> bx bx-table
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-duplicate"></i> bx bx-duplicate
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-windows"></i> bx bx-windows
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-window"></i> bx bx-window
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-window-open"></i> bx bx-window-open
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-wifi"></i> bx bx-wifi
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-voicemail"></i> bx bx-voicemail
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-video-off"></i> bx bx-video-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-usb"></i> bx bx-usb
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-upload"></i> bx bx-upload
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-alarm"></i> bx bx-alarm
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-tennis-ball"></i> bx bx-tennis-ball
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-target-lock"></i> bx bx-target-lock
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-tag"></i> bx bx-tag
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-tab"></i> bx bx-tab
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-spreadsheet"></i> bx bx-spreadsheet
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sitemap"></i> bx bx-sitemap
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sidebar"></i> bx bx-sidebar
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-send"></i> bx bx-send
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pie-chart"></i> bx bx-pie-chart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-phone"></i> bx bx-phone
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-navigation"></i> bx bx-navigation
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mobile"></i> bx bx-mobile
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-mobile-alt"></i> bx bx-mobile-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message"></i> bx bx-message
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-message-rounded"></i> bx
                      bx-message-rounded
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-map"></i> bx bx-map
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-map-alt"></i> bx bx-map-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-lock"></i> bx bx-lock
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-lock-open"></i> bx bx-lock-open
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-list-minus"></i> bx bx-list-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-list-ul"></i> bx bx-list-ul
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-list-plus"></i> bx bx-list-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-link"></i> bx bx-link
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-link-alt"></i> bx bx-link-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-layer"></i> bx bx-layer
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-laptop"></i> bx bx-laptop
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-home"></i> bx bx-home
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-heart"></i> bx bx-heart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-headphone"></i> bx bx-headphone
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-devices"></i> bx bx-devices
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-globe"></i> bx bx-globe
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-gift"></i> bx bx-gift
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-envelope"></i> bx bx-envelope
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-download"></i> bx bx-download
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dots-vertical"></i> bx
                      bx-dots-vertical
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dots-vertical-rounded"></i> bx
                      bx-dots-vertical-rounded
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dots-horizontal"></i> bx
                      bx-dots-horizontal
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dots-horizontal-rounded"></i> bx
                      bx-dots-horizontal-rounded
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-dollar"></i> bx bx-dollar
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-directions"></i> bx bx-directions
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-desktop"></i> bx bx-desktop
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-data"></i> bx bx-data
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-compass"></i> bx bx-compass
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-crosshair"></i> bx bx-crosshair
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-terminal"></i> bx bx-terminal
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud"></i> bx bx-cloud
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-upload"></i> bx bx-cloud-upload
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-cloud-download"></i> bx
                      bx-cloud-download
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chart"></i> bx bx-chart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar"></i> bx bx-calendar
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar-x"></i> bx bx-calendar-x
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar-minus"></i> bx
                      bx-calendar-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar-check"></i> bx
                      bx-calendar-check
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-calendar-plus"></i> bx
                      bx-calendar-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-buoy"></i> bx bx-buoy
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bulb"></i> bx bx-bulb
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bluetooth"></i> bx bx-bluetooth
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bug"></i> bx bx-bug
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-building"></i> bx bx-building
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-broadcast"></i> bx bx-broadcast
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-briefcase"></i> bx bx-briefcase
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bookmark-plus"></i> bx
                      bx-bookmark-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bookmark-minus"></i> bx
                      bx-bookmark-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-book"></i> bx bx-book
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-book-bookmark"></i> bx
                      bx-book-bookmark
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-block"></i> bx bx-block
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-basketball"></i> bx bx-basketball
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bar-chart"></i> bx bx-bar-chart
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bar-chart-square"></i> bx
                      bx-bar-chart-square
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bar-chart-alt"></i> bx
                      bx-bar-chart-alt
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-at"></i> bx bx-at
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-archive"></i> bx bx-archive
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-zoom-out"></i> bx bx-zoom-out
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-zoom-in"></i> bx bx-zoom-in
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-x-circle"></i> bx bx-x-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-volume"></i> bx bx-volume
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-volume-mute"></i> bx bx-volume-mute
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-volume-low"></i> bx bx-volume-low
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-volume-full"></i> bx bx-volume-full
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-video"></i> bx bx-video
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-vertical-center"></i> bx
                      bx-vertical-center
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-up-arrow-circle"></i> bx
                      bx-up-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-trending-up"></i> bx bx-trending-up
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-trending-down"></i> bx
                      bx-trending-down
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-toggle-right"></i> bx bx-toggle-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-toggle-left"></i> bx bx-toggle-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-time"></i> bx bx-time
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-sync"></i> bx bx-sync
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-stopwatch"></i> bx bx-stopwatch
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-stop"></i> bx bx-stop
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-stop-circle"></i> bx bx-stop-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-skip-previous"></i> bx
                      bx-skip-previous
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-skip-next"></i> bx bx-skip-next
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-show"></i> bx bx-show
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-search"></i> bx bx-search
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rss"></i> bx bx-rss
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-right-top-arrow-circle"></i> bx
                      bx-right-top-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-right-indent"></i> bx bx-right-indent
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-right-down-arrow-circle"></i> bx
                      bx-right-down-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-right-arrow-circle"></i> bx
                      bx-right-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-reset"></i> bx bx-reset
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rewind"></i> bx bx-rewind
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-rectangle"></i> bx bx-rectangle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-radio-circle"></i> bx bx-radio-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-radio-circle-marked"></i> bx
                      bx-radio-circle-marked
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-question-mark"></i> bx
                      bx-question-mark
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-plus-circle"></i> bx bx-plus-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-play"></i> bx bx-play
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-play-circle"></i> bx bx-play-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pause"></i> bx bx-pause
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-pause-circle"></i> bx bx-pause-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-moon"></i> bx bx-moon
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-minus-circle"></i> bx bx-minus-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-microphone"></i> bx bx-microphone
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-menu"></i> bx bx-menu
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-left-top-arrow-circle"></i> bx
                      bx-left-top-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-left-indent"></i> bx bx-left-indent
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-left-down-arrow-circle"></i> bx
                      bx-left-down-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-left-arrow-circle"></i> bx
                      bx-left-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-last-page"></i> bx bx-last-page
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-key"></i> bx bx-key
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-align-justify"></i> bx
                      bx-align-justify
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-info-circle"></i> bx bx-info-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-image"></i> bx bx-image
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-hide"></i> bx bx-hide
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-fullscreen"></i> bx bx-fullscreen
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-folder"></i> bx bx-folder
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-folder-plus"></i> bx bx-folder-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-folder-minus"></i> bx bx-folder-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-first-page"></i> bx bx-first-page
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-fast-forward"></i> bx bx-fast-forward
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-fast-forward-circle"></i> bx
                      bx-fast-forward-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-exit-fullscreen"></i> bx
                      bx-exit-fullscreen
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-error"></i> bx bx-error
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-error-circle"></i> bx bx-error-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-down-arrow-circle"></i> bx
                      bx-down-arrow-circle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-copyright"></i> bx bx-copyright
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-copy"></i> bx bx-copy
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-coffee"></i> bx bx-coffee
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-code"></i> bx bx-code
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-code-curly"></i> bx bx-code-curly
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-clipboard"></i> bx bx-clipboard
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevrons-left"></i> bx
                      bx-chevrons-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevrons-right"></i> bx
                      bx-chevrons-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevrons-up"></i> bx bx-chevrons-up
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevrons-down"></i> bx
                      bx-chevrons-down
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevron-right"></i> bx
                      bx-chevron-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevron-left"></i> bx bx-chevron-left
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevron-up"></i> bx bx-chevron-up
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-chevron-down"></i> bx bx-chevron-down
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-checkbox-square"></i> bx
                      bx-checkbox-square
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-checkbox"></i> bx bx-checkbox
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-checkbox-checked"></i> bx
                      bx-checkbox-checked
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-captions"></i> bx bx-captions
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-camera"></i> bx bx-camera
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-camera-off"></i> bx bx-camera-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bullseye"></i> bx bx-bullseye
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bookmarks"></i> bx bx-bookmarks
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bookmark"></i> bx bx-bookmark
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bell"></i> bx bx-bell
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bell-plus"></i> bx bx-bell-plus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bell-off"></i> bx bx-bell-off
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-bell-minus"></i> bx bx-bell-minus
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-arrow-back"></i> bx bx-arrow-back
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-align-right"></i> bx bx-align-right
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-align-middle"></i> bx bx-align-middle
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <i className="bx bx-align-left"></i> bx bx-align-left
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IconDripicons;
